<template>
  <div class="phone-call-confirmation-modal">
    <div class="modal-content-wrapper">
      <div class="question-section">
        <div class="icon-wrapper">
          <span class="icon-large">📞</span>
        </div>
        <h3 class="question-text">האם התקיימה שיחה אינפורמטיבית עם המועמד?</h3>
      </div>

      <div class="buttons-section">
        <div class="button-with-label">
          <button
            @click="handleYes"
            class="icon-button green-button"
            :class="{ 'is-loading': isLoadingYes }"
            :disabled="isLoadingYes || isLoadingNo"
          >
            <img width="35" src="/applicant_answered.svg" class="operation_icon" alt="Answered">
          </button>
          <span class="button-label">כן - התקיימה שיחה</span>
        </div>

        <div class="button-with-label">
          <button
            @click="handleNo"
            class="icon-button red-button"
            :class="{ 'is-loading': isLoadingNo }"
            :disabled="isLoadingYes || isLoadingNo"
          >
            <span class="phone-emoji">☎️</span>
          </button>
          <span class="button-label">לא התקיימה שיחת טלפון אינפורמטיבית</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneCallConfirmationModal',
  props: {
    applicantId: {
      type: Number,
      required: true
    },
    onYes: {
      type: Function,
      required: true
    },
    onNo: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      isLoadingYes: false,
      isLoadingNo: false
    }
  },
  methods: {
    async handleYes () {
      this.isLoadingYes = true

      try {
        await this.$network_utils.postStat({
          title: 'Applicant answered phone',
          designator: 'applicant_answered_phone',
          status: 'active',
          owner: this.$utils.getOwner().name,
          priority: 5,
          resource_type: 'Applicant',
          resource_id: this.applicantId
        })

        console.log('[PhoneCallConfirmationModal] Created applicant_answered_phone stat')

        this.$utils.emit('show_toast', {
          text: 'נרשם שהמועמד ענה לטלפון',
          type: 'success'
        })

        // Call the onYes callback (will open OfferStatusForm without default message)
        this.onYes()
      } catch (error) {
        console.error('[PhoneCallConfirmationModal] Error creating phone stat:', error)
        this.$utils.emit('show_toast', {
          text: 'שגיאה בשמירת המידע',
          type: 'error'
        })
      } finally {
        this.isLoadingYes = false
      }
    },

    handleNo () {
      this.isLoadingNo = true

      try {
        console.log('[PhoneCallConfirmationModal] User confirmed no phone call')

        this.onNo()
      } finally {
        this.isLoadingNo = false
      }
    }
  }
}
</script>

<style scoped>
.phone-call-confirmation-modal {
  padding: 2rem;
  background: #ffffff;
  border-radius: 8px;
}

.modal-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
}

/* Question Section */
.question-section {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.icon-wrapper {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.icon-large {
  font-size: 2rem;
}

.question-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  line-height: 1.4;
  direction: rtl;
}

/* Buttons Section */
.buttons-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  max-width: 500px;
}

.button-with-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.icon-button {
  background: transparent;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-button:not(:disabled):hover {
  transform: scale(1.1);
  opacity: 0.8;
}

.icon-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.icon-button.is-loading {
  position: relative;
  pointer-events: none;
}

.icon-button.is-loading::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #dbdbdb;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spinner 0.6s linear infinite;
}

.green-button {
  background-color: transparent;
}

.red-button {
  background-color: transparent;
}

.operation_icon {
  display: block;
}

.phone-emoji {
  font-size: 2rem;
}

.button-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  direction: rtl;
  text-align: center;
  line-height: 1.4;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .phone-call-confirmation-modal {
    padding: 1.5rem;
  }

  .question-text {
    font-size: 1.2rem;
  }

  .icon-wrapper {
    width: 60px;
    height: 60px;
  }

  .icon-large {
    font-size: 2rem;
  }

  .button-label {
    font-size: 1rem;
  }
}
</style>
